<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>{{isCreating?'Crea un afiliado':'Edita un afiliado'}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-4 container-image-affiliate" (click)="addPhoto()">
							<div class="image-affiliate"
								[style.backgroundImage]="affiliate.foto?'url('+affiliate.foto+')':'url(../../../../../assets/img/nophoto.svg)'">
							</div>
							<div class="superposition-image-affiliate">
								<p class="h1" style="text-align: center;"><i class="fa fa-edit"></i></p>
							</div>
						</div>
						<div class="col-sm-8">
							<div class="row">
								<div class="form-group col-sm">
									<label for="name" class="form-label">Nombre <span class="required">*</span></label>
									<input type="text" placeholder="Ingresa el nombre" name="name" id="name"
										[(ngModel)]="affiliate.nombre" class="form-control">
								</div>
								<div class="form-group col-sm">
									<label for="dpi" class="form-label">DPI <span class="required">*</span></label>
									<input type="text" placeholder="Ingresa el dpi" name="dpi" id="dpi"
										[(ngModel)]="affiliate.dpi" class="form-control">
								</div>
							</div>
							<div class="row">
								<div class="form-group col-sm">
									<label for="nit" class="form-label">NIT <span class="required">*</span></label>
									<div class="input-group">
										<app-input-autocomplete [filterElements]="vendor.filterElements"
											[allBorderRadius]="true" [placeholder]="'Ingresa el nit'"
											(getTitle)="$event.filterElement.title = $event.filterElement.name + ' - ' + $event.filterElement.nit"
											[inputs]="vendor"
											(inputMethod)="write($event.event)"
											(changeStatus)="select($event.filterElement)"
											></app-input-autocomplete>
									</div>
								</div>
								<div class="form-group col-sm">
									<label for="address" class="form-label">Direccion</label>
									<input type="text" placeholder="Ingresa la direccion" name="address" id="address"
										[(ngModel)]="affiliate.direccion" class="form-control">
								</div>
							</div>
							<div class="row">
								<div class="form-group col-sm">
									<label for="cellphone" class="form-label">Celular</label>
									<input type="text" placeholder="Ingresa el celular" name="cellphone" id="cellphone"
										[(ngModel)]="affiliate.celular" class="form-control">
								</div>
								<div class="form-group col-sm">
									<label for="email" class="form-label">Correo </label>
									<input type="text" placeholder="Ingresa el correo" name="email" id="email"
										[(ngModel)]="affiliate.mail" class="form-control">
								</div>
								<div class="form-group col-sm">
									<label for="birthday" class="form-label">Fecha de Nacimiento <span
											class="required">*</span></label>
									<input type="date" placeholder="Ingresa el correo" name="birthday" id="birthday"
										[(ngModel)]="affiliate.nacimiento" class="form-control">
								</div>
							</div>
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para {{isCreating?'crear el afiliado':'guardar los cambios'}} </p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="!affiliate.nombre || !affiliate.dpi || !affiliate.nit || !affiliate.nacimiento || loading"
						(click)="createOrEdit()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>{{isCreating?'CREAR':'EDITAR'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>